import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';

import Placeholder from 'components/consumer/Placeholder';
import useFixedWidthContainerSizeProps from 'hooks/useFixedWidthContainerSizeProps';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import PDPInfoTable from '../PDPInfoTable';

import Prefetcher from '../../../essentials/Prefetcher';

const PDPDimensionsContentUI = ({
  dimensionsDesktopImage,
  dimensionsMobileImage,
  dimensions = [],
  loading = false,
  onImageClick,
  isSidebarContent = false,
}) => {
  const desktopImageFullWidthProps = useFixedWidthContainerSizeProps();

  const desktopImageProps = isSidebarContent
    ? { sizes: '30vw' }
    : desktopImageFullWidthProps;

  return (
    <div className="PDPDimensionsContentUI">
      {loading && (
        <Placeholder
          loading
          type="rect"
          style={{ marginRight: 0, marginTop: '10px', height: '207px' }}
        />
      )}

      {!loading && (
        <>
          {dimensionsMobileImage && (
            <MobileAndTabletOnly>
              <JBImage
                src={dimensionsMobileImage}
                sizes="100vw"
                height="900"
                width="900"
                className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden"
              />
            </MobileAndTabletOnly>
          )}

          {dimensionsDesktopImage && (
            <DesktopOnly>
              <Prefetcher
                onHoverAssets={[
                  {
                    url: dimensionsDesktopImage,
                    imgixProps: {
                      ...desktopImageFullWidthProps,
                    },
                  },
                ]}
              >
                <JBImage
                  src={dimensionsDesktopImage}
                  onClick={onImageClick}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...desktopImageProps}
                  className={classNames(
                    'w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden',
                    {
                      'hover:cursor-target': onImageClick,
                    }
                  )}
                />
              </Prefetcher>
            </DesktopOnly>
          )}
        </>
      )}

      <div className="max-w-[480px] mx-auto my-0">
        <PDPInfoTable items={dimensions} loading={loading} />
      </div>
    </div>
  );
};

PDPDimensionsContentUI.propTypes = {
  dimensions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  dimensionsDesktopImage: PropTypes.string,
  dimensionsMobileImage: PropTypes.string,
  loading: PropTypes.bool,
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
};

export default PDPDimensionsContentUI;
